import { getModalContainer, modal, getModalFooterContainer, getModalBodyContainer, getModalHeader } from "../Modal/Modal.js";
import { ButtonProps, defaultProps, modalMain, modalCancel } from "../Button/Button.js";
import * as react from "react";

export function renderWithButtonProps(isOpen, modalSize, headerText, bodyHtml, cancelButtonProps, acceptButtonProps) {
    let children;
    const modalHeaderHtml = getModalHeader(headerText, cancelButtonProps.OnClick);
    const modalBodyHtml = getModalBodyContainer(bodyHtml);
    const modalFooterHtml = getModalFooterContainer((children = [modalCancel(cancelButtonProps), modalMain(acceptButtonProps)], react.createElement(react.Fragment, {}, ...children)));
    return modal(isOpen, getModalContainer(modalSize, react.createElement("div", {}, modalHeaderHtml, modalBodyHtml, modalFooterHtml)));
}

export function render(isOpen, modalSize, headerText, bodyHtml, cancelButtonText, acceptButtonText, cancelButtonFn, acceptButtonFn) {
    return renderWithButtonProps(isOpen, modalSize, headerText, bodyHtml, new ButtonProps(cancelButtonText, defaultProps.Content, (arg) => {
        cancelButtonFn(arg);
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon), new ButtonProps(acceptButtonText, defaultProps.Content, (arg_1) => {
        acceptButtonFn(arg_1);
    }, defaultProps.Disabled, defaultProps.Id, defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon));
}

